<script>
import LoginComponent from '@/components/LoginComponent';

export default {
  name: 'LandingHeader',
  components: { LoginComponent },
  data() {
    return {
      showLoginModal: false,
    };
  },
  computed: {
    smallScreen() {
      if (this.$store.state.windowWidth > 500) return false;
      return true;
    },
  },
};
</script>

<template>
  <div>
    <div class="page-header">
      <img class="page-header__stone" src="@/assets/images/stone_white_shadow.png" alt="" />
      <div class="school-name">
        <p>Guo Juan's</p>
        <h1>Internet Go School</h1>
      </div>
      <button
        type="button"
        class="login-link btn btn-sm"
        :class="{ 'btn-link': smallScreen, higher: smallScreen, 'btn-outline-white': !smallScreen }"
        @click="showLoginModal = true"
      >
        Login
      </button>
    </div>

    <!-- start login modal -->
    <b-modal v-model="showLoginModal" hide-header-close hide-footer title="Login">
      <template #default>
        <login-component
          @pw-reset-clicked="showLoginModal = false"
          @register-clicked="showLoginModal = false"
          @failed-login="showLoginModal = false"
        />
      </template>
    </b-modal>
    <!-- end login modal -->
  </div>
</template>

<style lang="scss" scoped>
.login-link {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: var(--page-text-inverse-color);
  font-size: 0.8rem;
}
.higher {
  top: 0;
}

.school-name {
  text-align: left;
  margin: auto;
  padding-top: 1rem;
  width: fit-content;
}
.school-name > * {
  color: var(--page-text-inverse-color);
  text-shadow: var(--text-emph-shadow);
}

.school-name p {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.school-name h1 {
  font-size: 1.7rem;
}

.page-header {
  position: fixed;
  display: grid;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 20vw;
  overflow: hidden;
  background-color: var(--nav-background-color);
  &__stone {
    position: absolute;
    height: 22vw;
    width: 22vw;
    top: -3.6vw;
    left: -3.6vw;
  }
}

.btn-outline-white {
  background-color: transparent;
  color: var(--page-text-inverse-color);
  border-color: var(--text-emph);
}

@media (min-width: 530px) {
  .school-name p {
    font-size: 2rem;
  }
  .school-name h1 {
    font-size: 2.7rem;
  }
  .page-header {
    height: 18vw;
    &__stone {
      height: 20vw;
      width: 20vw;
      top: -3.3vw;
      left: -3.3vw;
    }
  }
}
@media (min-width: 800px) {
  .page-header {
    height: 16vw;
    &__stone {
      height: 18vw;
      width: 18vw;
      top: -3.1vw;
      left: -3vw;
    }
  }
}
@media (min-width: 1100px) {
  .page-header {
    height: 14vw;
    &__stone {
      height: 16vw;
      width: 16vw;
      top: -2.8vw;
      left: -2.7vw;
    }
  }
}
</style>
